import React from 'react';
import { personal } from '../data/resume';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      <div className="grid-bg" />
      <div className="grid-fade" />
      <div className="hero-inner">
        <div className="hero-tag">
          <span className="dot-pulse" />
          Open to Opportunities · {personal.graduationYear}
        </div>

        <h1 className="hero-name">
          {personal.name}
        </h1>

        <p className="hero-title mono">{personal.title}</p>

        <p className="hero-sub">{personal.summary}</p>

        <div className="hero-cta">
          <a className="btn btn-primary" href="#experience">
            View Experience
          </a>
          <a className="btn btn-outline" href={`mailto:${personal.email}`}>
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
}
